<template>
  <div class="block">
    <el-date-picker
      v-model="value"
      type="daterange"
      range-separator="~"
      start-placeholder="開始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      @change="changeTime"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: '',
    }
  },
  methods: {
    changeTime() {
      this.$emit('changeTime', this.value)
    },
    clearData() {
      this.value = ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/DatePicker.vue